import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("ventai_user")); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // If returning from Google OAuth, AuthCallback handles the session exchange
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    const token = localStorage.getItem("ventai_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me").then((r) => {
      setUser(r.data);
      localStorage.setItem("ventai_user", JSON.stringify(r.data));
    }).catch(() => {
      localStorage.removeItem("ventai_token");
      localStorage.removeItem("ventai_user");
      setUser(null);
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ventai_token", data.access_token);
    localStorage.setItem("ventai_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("ventai_token", data.access_token);
    localStorage.setItem("ventai_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const loginWithGoogle = async (sessionId) => {
    const { data } = await api.post("/auth/google", { session_id: sessionId });
    localStorage.setItem("ventai_token", data.access_token);
    localStorage.setItem("ventai_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("ventai_token");
    localStorage.removeItem("ventai_user");
    setUser(null);
    window.location.href = "/login";
  };

  const updateUser = (u) => {
    setUser(u);
    if (u) localStorage.setItem("ventai_user", JSON.stringify(u));
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, loginWithGoogle, logout, setUser: updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
